<template>
  <div class="calendarMonth">
    <div class="calendarMonthHeader">
      {{ header }}
    </div>
    <div class="calendarDaysOfTheWeek">
      <div>Sun</div><div>Mon</div><div>Tue</div><div>Wed</div><div>Thu</div><div>Fri</div><div>Sat</div>
    </div>
    <div class="calendarDays">
      <!-- insert blank placeholders as necessary so day 1 of the month starts on the correct day -->
      <div
        v-for="n in firstDay"
        :key="'placeholder-'+n"
      />
      <!-- insert the days of the month -->
      <div
        v-for="d in daysInMonth"
        :key="d"
        :data-automation="isDateActive(d) ? 'date-active' : null"
        :class="{selectable: isDateActive(d), selected: isDateSelected(d)}"
        @click="handleDateClick(d)"
      >
        {{ d }}
      </div>
    </div>
  </div>
</template>

<script>

import { format, isSameDay } from 'date-fns'

export default {
  name: 'CalendarMonth',
  props: {
    month: {
      type: Object,
      required: true,
    },
    selectedDate: {
      type: Date,
      required: false,
      default: null,
    },
    handleSelectDate: {
      type: Function,
      required: true,
    },
  },
  computed: {
    dayOneDate: function () { // date object for the first day of the month
      return new Date(this.month.year, this.month.month, 1)
    },
    firstDay: function () { // day of the week of the 1st of the month - Sunday is 0
      return this.dayOneDate.getDay()
    },
    daysInMonth: function () {
      return new Date(this.month.year, this.month.month + 1, 0).getDate()
    },
    header: function () {
      // safe to format; above is a Date instance
      return format(this.dayOneDate, 'MMMM yyyy')
    },
  },
  methods: {
    // NOTE: "date" attributes here are the day, not a full Date object.
    isDateActive: function (d) {
      return this.month.activeDates.find((element) => element.date === d)
    },
    isDateSelected: function (d) {
      if (!this.selectedDate) {
        return false
      }
      return isSameDay(this.selectedDate, new Date(this.month.year, this.month.month, d))
    },
    handleDateClick: function (d) {
      const td = this.isDateActive(d)
      if (td) {
        this.handleSelectDate(new Date(this.month.year, this.month.month, d))
      }
    },
  },
}

</script>
